import { Mono } from '@/components/ui/Text';
import { colors } from '@/theme/tokens';
import styles from './SparkBar.module.css';

interface SparkBarProps {
  /** One value per day, each 0–1 relative to the week's peak. */
  values: number[];
  height?: number;
  caption?: string;
}

/** Seven-day sales trend under the debt hero. The final bar (today) is highlighted. */
export function SparkBar({ values, height = 34, caption = '7 ມື້' }: SparkBarProps) {
  return (
    <div className={styles.row} style={{ height }}>
      {values.map((v, i) => (
        <div
          key={i}
          className={styles.bar}
          style={{
            height: `${Math.max(4, Math.min(1, v) * 100)}%`,
            background: i === values.length - 1 ? colors.sky : 'rgba(255,255,255,0.22)',
          }}
        />
      ))}
      <Mono size={9} color={colors.onDarkSoft} className={styles.caption}>
        {caption}
      </Mono>
    </div>
  );
}
